/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import identity from 'lodash/identity';
import type {
	StringifiableValue,
	UrlTransform,
} from '@jira/platform__bind-url-to-state/src/index.tsx';

export const string: UrlTransform = {
	stringify: identity,
	parse: identity,
} as const;

export const bool: UrlTransform = {
	stringify: (value) => String(value),
	parse: (value) => {
		if (value === 'true') {
			return true;
		}

		if (value === 'false') {
			return false;
		}

		return undefined;
	},
} as const;

// Use for comma separated array query string parameters
// Example - ?assignee=user1,user2,user3
export const array: UrlTransform = {
	stringify: (value: StringifiableValue) =>
		value && Array.isArray(value) ? value.join(',') : undefined,
	parse: (value: StringifiableValue): StringifiableValue =>
		typeof value === 'string' ? value?.split(',') : undefined,
} as const;

// Use for multiple query string parameters using same key
// Examples:
//  - ?assignee=user1  --->  'user1'
//  - ?assignee=user1&assignee=user2&assignee=user3  --->  ['user1', 'user2', 'user3']
// Format used in CMP board/backlog
export const multiple: UrlTransform = {
	stringify: (value: StringifiableValue) => {
		if (!value || !Array.isArray(value)) return undefined;

		return value.length === 1 ? value[0] : value;
	},
	parse: (value: StringifiableValue): StringifiableValue =>
		value && Array.isArray(value) ? value : [String(value)],
} as const;

export const number: UrlTransform = {
	stringify: (value: StringifiableValue) => `${value}`,
	parse: (value: StringifiableValue) => Number(value),
} as const;
